var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"author"}},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.author.name)+" Posts")]),_c('p',[_vm._v(_vm._s(_vm.author.description))]),_c('list-posts',{attrs:{"posts":_vm.posts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }